import React from "react";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHeader,
  TableRow,
} from "../components/table";
import { capitalize } from "./strings";

type DataRowsProps<T> = {
  data: T;
  className?: string;
  fields?: {
    [K in keyof T]?: {
      label?: string;
      render?: (val: T[K]) => React.ReactNode;
      hidden?: boolean;
    };
  };
  caption?: string;
};

export const DataRows = <T extends Object>(
  { data, caption, fields: config, className }: DataRowsProps<T>,
) => {
  return (
    <Table className={className}>
      {caption && <TableCaption className="text-white">{caption}</TableCaption>}
      <TableHeader>
      </TableHeader>
      <TableBody>
        {Object.keys(data).filter((x) =>
          !config || !(config[x as keyof T]?.hidden)
        ).map(
          (objKey) => {
            const key = objKey as keyof T;
            const render = config && config[key]?.render;
            return (
              <TableRow key={objKey}>
                <TableCell className="px-0 content-start">
                  {(config && config[key]?.label) ?? capitalize(key)}
                </TableCell>
                <TableCell className="px-0">
                  {render
                    ? render(data[key])
                    : ((data[key] != undefined && data[key] != null)
                      ? (data[key] as any)
                      : "")}
                </TableCell>
              </TableRow>
            );
          },
        )}
      </TableBody>
    </Table>
  );
};
